import { Notification } from 'element-ui'
// //////////////////////////////////////////
//   localStorage
// //////////////////////////////////////////
/**
 * 存储localStorage
 */
function localSetStore (name, content) {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}
/**
 * 获取localStorage
 */
function localGetStore (name) {
  if (!name) return
  return window.localStorage.getItem(name)
}
/**
 * 删除localStorage
 */
function localRemoveStore (name) {
  if (!name) return
  window.localStorage.removeItem(name)
}
/**
 * 删除所有localStorage
 */
function localClearStore () {
  window.localStorage.clear()
}
// //////////////////////////////////////////
//
//   sessionStorage
//
// //////////////////////////////////////////
/**
 * 存储sessionStorage                                         
 */
function sessionSetStore (name, content) {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.sessionStorage.setItem(name, content)
}
/**
 * 获取sessionStorage
 */
function sessionGetStore (name) {
  if (!name) return
  return window.sessionStorage.getItem(name)
}
/**
 * 删除sessionStorage
 */
function sessionRemoveStore (name) {
  if (!name) return
  window.sessionStorage.removeItem(name)
}
/**
 * 删除所有sessionStorage
 */
function sessionClearStore () {
  window.sessionStorage.clear()
}

// 可关闭式通知提示，titlePara为标题，messagePara为通知内容
function notificationInfo (titlePara, messagePara, type) {
  let obj = {
    title: titlePara,
    message: `${messagePara}`
  }
  if (type) { 
    obj.type = type
  }
  Notification(obj)
}

// 产生随机整数，包含下限值，包括上限值
function createRandomNum (lower, upper) {
  return Math.floor(Math.random() * (upper - lower + 1)) + lower
}

// 数组每n个分一组，作为元素组成新数组
function arrayGroup (num, arr) {
  let newArr = []
  for (let i = 0; i < arr.length; i += num) {
    newArr.push(arr.slice(i, (i + num)))
  }
  return newArr
}

let utils = {
  localSetStore,
  localGetStore,
  localRemoveStore,
  localClearStore,
  sessionSetStore,
  sessionGetStore,
  sessionRemoveStore,
  sessionClearStore,
  notificationInfo,
  createRandomNum,
  arrayGroup
}
export default utils
